import { endpoints } from 'Constants';

const packageServices = {
	fetchV2Packages: (params) => ({
		baseURL: endpoints.PACKAGE.GET_V2_PACKAGES(params),
		method: 'GET',
	}),
	fetchV1Packages: (params) => ({
		baseURL: endpoints.PACKAGE.GET_V1_PACKAGES(params),
		method: 'GET',
	}),
	updateStatus: (params) => ({
		baseURL: endpoints.PACKAGE.UPDATE_STATUS(params),
		method: 'POST',
		data: { status: params.status },
	}),
	create: (params) => ({
		baseURL: endpoints.PACKAGE.CREATE(params),
		method: 'POST',
		data: params,
	}),
	update: (params) => ({
		baseURL: endpoints.PACKAGE.GET_V1_PACKAGES(params),
		method: 'PUT',
		data: params,
	}),
	BestSelling: (params) => ({
		baseURL: endpoints.PACKAGE.BEST_SELLING(params),
		method: 'GET',
	}),
};

export default packageServices;
